import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";

function UnderConstruction() {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-blue-50 to-blue-100 px-6">
      <div className="text-center max-w-xl">
        {/* Optional animated image or icon */}
        <img
          src="images/undcon.png"
          alt="Under Construction"
          className="w-full mx-auto mb-8"
        />

        <p className="text-gray-600 mb-6">
          We’re working hard to finish the development of this page. We’ll be
          ready soon! Stay tuned and feel free to get in touch.
        </p>

        <div className="flex justify-center gap-4 mb-6">
          <a
            href="mailto:contact@example.com"
            className="text-blue-700 hover:text-blue-900 transition text-xl"
            title="Email"
          >
            <FaEnvelope />
          </a>
          <a
            href="https://facebook.com"
            className="text-blue-700 hover:text-blue-900 transition text-xl"
            title="Facebook"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>
          <a
            href="https://twitter.com"
            className="text-blue-700 hover:text-blue-900 transition text-xl"
            title="Twitter"
            target="_blank"
            rel="noreferrer"
          >
            <FaTwitter />
          </a>
          <a
            href="https://instagram.com"
            className="text-blue-700 hover:text-blue-900 transition text-xl"
            title="Instagram"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </a>
        </div>

        <p className="text-sm text-gray-500">
          © {new Date().getFullYear()} Fahim Ferdous. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default UnderConstruction;
